import { ReactNode } from "react";
import { Nft, SecondNftForGallery } from "../../../types/nftType";
import CloseBtn from "../../common/ui/CloseBtn";
import OpenSeaBtn from "../../common/ui/OpenSeaBtn";
import PrimaryAnimatedBtn from "../../common/ui/PrimaryAnimatedBtn";
import styles from "./geneDetail.module.scss";

export const GeneItemDescription = <Gene extends Nft | SecondNftForGallery>({
  isMyGene,
  currentGene,
  onClickCloseBtn,
  isMobile,
  answerText,
  onChangeAnswerText,
  creditText,
  onChangeCreditText,
  onClickEdit,
  attrs,
  openSeaLinkPrefix,
  showsPcEditBtn,
  showsMobileEditBtn,
  children,
}: {
  isMyGene: boolean;
  currentGene: Gene;
  onClickCloseBtn: () => void;
  isMobile: boolean;
  answerText: string;
  onChangeAnswerText: (event: React.ChangeEvent<HTMLInputElement>) => void;
  creditText: string;
  onChangeCreditText: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClickEdit: (tokenId: string, answer: string, credit: string) => void;
  attrs: [string, keyof Nft][];
  openSeaLinkPrefix: string;
  showsPcEditBtn: boolean;
  showsMobileEditBtn: boolean;
  children: ReactNode;
}) => {
  return (
    <div className={styles.geneItemDescription}>
      <div className={styles["gene-title-wrap"]}>
        <div className={styles["gene-title-wrapper"]}>
          {isMyGene && <div className={styles.labelMine}>YOURGENE</div>}
          <p className={styles["gene-title"]}>
            GENE N_{currentGene.tokenId!.padStart(4, "0")}
          </p>
        </div>
        <div className={styles["gene-title-icons"]}>
          <OpenSeaBtn href={`${openSeaLinkPrefix}${currentGene.tokenId}`} />
          <CloseBtn
            onClick={onClickCloseBtn}
            extraClass={isMobile ? "absolute top-[60px]" : ""}
          />
        </div>
      </div>
      <div className="mt-2 pl-2">
        <p className={styles["gene-description-text"]}>TARGET: NEN</p>
        <p className={styles["gene-description-text"]}>
          {/* DNA: {currentGene.attributeDna} */}
          {children}
        </p>
        <p className={styles["gene-description-text"]}>
          QUESTION: {currentGene.question}
        </p>
        {isMyGene ? (
          <>
            <div className="flex justify-between items-stretch mt-1">
              <div className="flex-1">
                {currentGene.isAnswerLocked ? (
                  <>
                    <p className={styles["gene-description-text"]}>
                      ANSWER: {currentGene.answer}
                    </p>
                    <p className={styles["gene-description-text"]}>
                      CREDIT: {currentGene.credit}
                    </p>
                  </>
                ) : (
                  <>
                    <div className="flex">
                      <p className={styles["gene-description-text"] + " w-14"}>
                        ANSWER:
                      </p>
                      <input
                        className="flex-1 bg-transparent text-white outline-none ml-2 px-2 border border-white"
                        placeholder="Please fill in the form"
                        type="text"
                        maxLength={20}
                        value={answerText}
                        onChange={onChangeAnswerText}
                      />
                    </div>
                    <div className="flex mt-1">
                      <p className={styles["gene-description-text"] + " w-14"}>
                        CREDIT:
                      </p>
                      <input
                        className="flex-1 bg-transparent text-white outline-none ml-2 px-2 border border-white"
                        placeholder={"Please fill in the form"}
                        type={"text"}
                        maxLength={20}
                        value={creditText}
                        onChange={onChangeCreditText}
                      />
                    </div>
                  </>
                )}
              </div>
              {showsPcEditBtn && (
                <div className="w-20 ml-2">
                  <PrimaryAnimatedBtn
                    onClick={() =>
                      onClickEdit(currentGene.tokenId!, answerText, creditText)
                    }
                    extraClass="w-full h-full"
                  >
                    EDIT
                  </PrimaryAnimatedBtn>
                </div>
              )}
            </div>
            {showsMobileEditBtn && (
              <div className="mt-[12px]">
                <PrimaryAnimatedBtn
                  onClick={() =>
                    onClickEdit(currentGene.tokenId!, answerText, creditText)
                  }
                  extraClass="w-full h-[48px]"
                >
                  EDIT
                </PrimaryAnimatedBtn>
              </div>
            )}
          </>
        ) : (
          <div className="flex justify-between items-stretch mt-1">
            <div className="flex-1">
              <p className="text-base">Answer: {currentGene.answer}</p>
              <p className="text-base">CREDIT: {currentGene.credit}</p>
            </div>
          </div>
        )}
      </div>
      <div className="mt-6">
        <ul className={styles["slill-list-area"]}>
          {attrs.map((e, i) => (
            <Li key={i} currentGene={currentGene} title={e[0]} attr={e[1]} />
          ))}
        </ul>
      </div>
    </div>
  );
};

const Li = <Gene extends Nft | SecondNftForGallery>({
  currentGene,
  title,
  attr,
}: {
  currentGene: Gene;
  title: string;
  attr: keyof Gene;
}) => (
  <li className={styles["slill-list-item"]}>
    {`${title} / ${currentGene[attr] || "None"}`}
  </li>
);
